import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import eiqSecureLiveActivityStore from 'features/eiq-secure/stores/live-activity/live-activity.store';
import { LiveActivityFeed } from 'common/components/live-activity/live-activity-feed';

export const LiveActivity = observer(() => {
  useEffect(() => {
    eiqSecureLiveActivityStore.init();
  }, []);

  return <LiveActivityFeed logs={eiqSecureLiveActivityStore.liveActivityLogs} />;
});
